import { useSelector } from "react-redux";

import { getSeasonName } from "../../helpers/seasonName";
import { getSeasonImage } from "../../helpers/season";
import { getConservatoryAlias } from "../../helpers/conservatories";
import { formatPrice } from "../../helpers/formatPrice";

// Shared by the expanded preview and the collapsed bar so the two surfaces
// cannot disagree about naming or price formatting.
export const usePreviewData = () => {
  const init = useSelector((state) => state.init);
  const Uterum = useSelector((state) => state.Uterum);
  const Result = useSelector((state) => state.Result);

  const { alias, currency } = init;
  const { Season, FrameType, FrameWidth, FrameDepth } = Uterum;
  const { SquareMeterStomme, Price, OrdinaryPrice, Discounts, ProductDiscount } =
    Result;

  const hasProductDiscounts = Price !== OrdinaryPrice && ProductDiscount >= 1;

  return {
    alias,
    frameType: FrameType,
    frameTypeTitle: getConservatoryAlias(FrameType, alias),
    seasonTitle: getSeasonName(alias, Season),
    seasonIconName: getSeasonImage(Season).iconName,
    squareMeter: SquareMeterStomme,
    frameWidth: FrameWidth,
    frameDepth: FrameDepth,
    formattedPrice: formatPrice(Price, currency),
    formattedOrdinaryPrice: formatPrice(OrdinaryPrice, currency),
    formattedProductDiscount: formatPrice(ProductDiscount, currency),
    discounts: Discounts,
    hasProductDiscounts,
    hasAnyDiscount: hasProductDiscounts || Discounts.length > 0,
  };
};
